module.exports = __webpack_public_path__ + "img/bgloginsport.742a1f99.png";